// src/utils/analytics.js
import ReactGA from "react-ga4";

// NÃO use import.meta aqui — só process.env e window
const GA_MEASUREMENT_ID = (() => {
  const fromCRA = process.env.REACT_APP_GA_ID;
  const fromWindow =
    typeof window !== "undefined" && window.__GA_ID__ ? window.__GA_ID__ : "";
  // fallback de desenvolvimento (troque por vazio se preferir)
  const fallback = "G-3XXGZ6NJL2";
  return (fromCRA || fromWindow || fallback).toString();
})();

let GA_INITIALIZED = false;

export function initGA() {
  if (!GA_INITIALIZED && GA_MEASUREMENT_ID && GA_MEASUREMENT_ID.startsWith("G-")) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    GA_INITIALIZED = true;
  }
}

export function logPageView(path) {
  if (!GA_INITIALIZED) return;
  ReactGA.send({ hitType: "pageview", page: path });
}

export function logEvent({ action, category, label, value }) {
  if (!GA_INITIALIZED) return;
  ReactGA.event({ action, category, label, value });
}

/** GA4 Ecommerce — purchase */
export function logPurchase(params) {
  if (!GA_INITIALIZED) return;
  ReactGA.gtag("event", "purchase", params);
}

export function logEventGA4(name, params = {}) {
  if (!GA_INITIALIZED) return;
  ReactGA.gtag("event", name, params);
}


// // src/utils/analytics.js
// import ReactGA from "react-ga4";

// const GA_MEASUREMENT_ID =
//   import.meta?.env?.VITE_GA_ID ||
//   process.env.REACT_APP_GA_ID ||
//   "G-3XXGZ6NJL2";

// let GA_INITIALIZED = false;

// export function initGA() {
//   if (!GA_INITIALIZED && GA_MEASUREMENT_ID && GA_MEASUREMENT_ID.startsWith("G-")) {
//     ReactGA.initialize(GA_MEASUREMENT_ID);
//     GA_INITIALIZED = true;
//   }
// }

// export function logPageView(path) {
//   if (!GA_INITIALIZED) return;
//   ReactGA.send({ hitType: "pageview", page: path });
// }

// export function logEvent({ action, category, label, value }) {
//   if (!GA_INITIALIZED) return;
//   ReactGA.event({ action, category, label, value });
// }

// /**
//  * GA4 Ecommerce — purchase
//  * Docs GA4: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?hl=pt-br#purchase
//  * Exige pelo menos: transaction_id, value, currency. items é opcional mas recomendado.
//  */
// export function logPurchase(params) {
//   if (!GA_INITIALIZED) return;
//   // Chamada direta ao gtag para garantir o payload e-commerce completo
//   ReactGA.gtag("event", "purchase", params);
// }
// // Dispara eventos GA4 por nome + params (via gtag)
// export function logEventGA4(name, params = {}) {
//   if (!GA_INITIALIZED) return;
//   // usa a mesma ponte do logPurchase
//   ReactGA.gtag("event", name, params);
// }

